// loads scripts that need to be on page - every entrypoint should import this!
import { AdLoader, lazyload } from '@datagraphics/cookbook';
import _ from 'lodash';
import { intcomma } from 'journalize';

document.addEventListener('DOMContentLoaded', () => {
  // Kickstart image lazy loading
  lazyload();
  // Kickstart ads
  const adLoader = new AdLoader({ adSection: window.AD_SECTION });
  adLoader.init();
});

import Calculator from './Calculator.svelte';

const calculator = document.getElementById('calc-wrapper');
new Calculator({
  target: calculator,
});

// const slider = document.getElementById('home-slider');
// const medianA = document.getElementById('median_a');
// const medianB = document.getElementById('median_b');
// const medianC = document.getElementById('median_c');
// const medianD = document.getElementById('median_d');
// const homeInput = document.getElementById('home-price');
// medianA.innerHTML = '360,000';
// medianB.innerHTML = '360,001';
// medianC.innerHTML = '720,000';
// medianD.innerHTML = '720,000';

// document.querySelectorAll('.inputChange').forEach((item) => {
//   item.addEventListener('blur', (event) => {
//     console.log('blurred');
//     debouncedUpdateMapStyle(something);

//     let medianb = Number(something) + 1;
//     let medianc = something * 2;

//     medianA.innerHTML = `${intcomma(something)}`;
//     medianB.innerHTML = `${intcomma(medianb)}`;
//     medianC.innerHTML = `${intcomma(medianc)}`;
//     medianD.innerHTML = `${intcomma(medianc)}`;
//   });
// });

// slider.addEventListener('change', (e) => {
//   debouncedUpdateMapStyle(something);
//   console.log('changing', something);
//   let medianb = Number(something) + 1;
//   let medianc = something * 2;
//   medianA.innerHTML = `${intcomma(something)}`;
//   medianB.innerHTML = `${intcomma(medianb)}`;
//   medianC.innerHTML = `${intcomma(medianc)}`;
//   medianD.innerHTML = `${intcomma(medianc)}`;
// });

// slider.onchange = function () {
//   debouncedUpdateMapStyle(this.value);
//   console.log("changing", this.value)
//   let medianb = Number(this.value) + 1;
//   let medianc = this.value * 2;
//   medianA.innerHTML = `${intcomma(this.value)}`;
//   medianB.innerHTML = `${intcomma(medianb)}`;
//   medianC.innerHTML = `${intcomma(medianc)}`;
//   medianD.innerHTML = `${intcomma(medianc)}`;
// };
